
import React from "react";
import { ClientDetailWrapper } from "./ClientDetailWrapper";
import { ClientHeader } from "./ClientHeader";
import { ClientProgramSection } from "./ClientProgramSection";
import { ClientActivitySection } from "./ClientActivitySection";
import { ClientPersonalInfoSection } from "./ClientPersonalInfoSection";
import { ClientMetricsSection } from "./ClientMetricsSection";
import type { Client } from "@/types";

interface ClientDetailContentProps {
  client: Client;
  avatarUrl: string;
  name: string;
}

export const ClientDetailContent = ({ client, avatarUrl, name }: ClientDetailContentProps) => {
  return (
    <ClientDetailWrapper avatarUrl={avatarUrl} name={name}>
      <main className="p-6 space-y-4 overflow-y-auto h-[calc(100vh-64px)]">
        <ClientHeader client={client} />

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 pb-6">
          <div className="lg:col-span-3 grid grid-rows-2 gap-4">
            <ClientProgramSection client={client} />
            <ClientActivitySection client={client} />
          </div>

          <div className="lg:col-span-1 grid grid-rows-2 gap-4">
            <ClientPersonalInfoSection client={client} />
            <ClientMetricsSection client={client} />
          </div>
        </div>
      </main>
    </ClientDetailWrapper>
  );
};
